
import React from 'react'
import { mdx } from '@mdx-js/react'

/* @jsx mdx */
import { Notes } from 'mdx-deck'
import myTheme from './theme'
import submarine from './submarine_cables.png' 
import spacejam from './spacejam.png'
export const theme = myTheme;
const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope")
  return <div {...props}/>
};

const layoutProps = {
  theme
};
const MDXLayout = "wrapper"
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


    <h1>{`Hello, `}<em parentName="h1">{`world`}</em>{`!`}</h1>
    <hr></hr>
    <h1>{`Intro to web development`}</h1>
    <hr></hr>
    <h1>{`But first, what is the web?`}</h1>
    <Notes mdxType="Notes">
      <ul>
        <li parentName="ul">{`short for WWW (prefix for all websites)`}</li>
        <li parentName="ul">{`Part of the internet that you can interact with (websites, servers)`}</li>
        <li parentName="ul">{`when you interact with a fewsite eg uploading a photo, it sends a request to a server and the server caluclates the response. `}</li>
        <li parentName="ul">{`servers It's like a computer (doesn't have a screen or keyboard) that runs on its own and responsible for responding to requests from the client. `}</li>
        <li parentName="ul">{`the request and response goes through the internet`}</li>
        <li parentName="ul">{`the client (you) asks the server for information. The server returns the content to you`}</li>
      </ul>
    </Notes>
    <hr></hr>
    <h1>{`The internet`}</h1>
    <Notes mdxType="Notes">
      <ul>
        <li parentName="ul">{`There are underwater cables (copper for old ones, or fibre optics for new ones) that connect the internet to different land masses`}</li>
        <li parentName="ul">{`fiber optics cables are glass wires that we fire light through and it's picked up on the optic sensors on the other side.`}</li>
        <li parentName="ul">{`There are also cables that go underground to connect different cites/towns etc`}</li>
        <li parentName="ul">{`whole world is connected by cables from machine to machine/ `}</li>
        <li parentName="ul">{`sometimes satalites are used (more expensive and slower because they're further away without being connected)`}</li>
        <li parentName="ul">{`speed of internet can only go as fast as light. `}</li>
        <li parentName="ul">{`europe to america in 0.15seconds (150 miliseconds)`}</li>
      </ul>
    </Notes>
    <p><a parentName="p" {...{
        "href": "https://www.submarinecablemap.com/#/"
      }}>{`Submarine cables!`}</a></p>
    <img src={submarine} alt="submarine cables" />
    <hr></hr>
    <h1>{`Why do we create websites?`}</h1>
    <Notes mdxType="Notes">
      <ul>
        <li parentName="ul">{`give information (first website was used to publish research papers for CERN (brit, belgian and a french man))`}</li>
        <li parentName="ul">{`sell products `}</li>
        <li parentName="ul">{`to communicate`}</li>
        <li parentName="ul">{`watching dog videos`}</li>
        <li parentName="ul">{`play online games `}</li>
        <li parentName="ul">{`create presentations`}</li>
      </ul>
    </Notes>
    <hr></hr>
    <h1>{`And what do we mean by web development?`}</h1>
    <Notes mdxType="Notes">
      <ul>
        <li parentName="ul">{`making a website`}</li>
        <li parentName="ul">{`adding new features and improving exisiting features`}</li>
        <li parentName="ul">{`maintaining/bug fixing`}</li>
      </ul>
    </Notes>
    <hr></hr>
    <h1>{`Key components of a website`}</h1>
    <Notes mdxType="Notes">
      <ul>
        <li parentName="ul">{`user friendly, easy to use, it does what it is meant to do`}</li>
        <li parentName="ul">{`accessible`}</li>
        <li parentName="ul">{`There are three main categories: content, design and interactivety. Every time you save something, or request new data, it goes to the server`}</li>
        <li parentName="ul">{`How easy it is to find your website`}</li>
      </ul>
    </Notes>
    <hr></hr>
    <h1>{`HTML`}</h1>
    <Notes mdxType="Notes">
      <ul>
        <li parentName="ul">{`Hypertext markup language -- structure of the text so it's readable by computers and humans`}</li>
        <li parentName="ul">{`markup structure of a page so that it's able to be transformed for users and for all computers`}</li>
        <li parentName="ul">{`but why? -> used to structure text and works across all browsers (Brave, IE, edge, chrome etc etc)`}</li>
        <li parentName="ul">{`important to have web standards so things don't break and so they work in all browsers`}</li>
      </ul>
    </Notes>
    <hr></hr>
    <h1>{`CSS`}</h1>
    <Notes mdxType="Notes">
      <ul>
        <li parentName="ul">{`cascading style sheets`}</li>
        <li parentName="ul">{`the styling is passed down (order is important)`}</li>
        <li parentName="ul">{`it makes your website look good (colours, layout etc)`}</li>
        <li parentName="ul">{`it allows you to style it different depending on screen size`}</li>
      </ul>
    </Notes>
    <p><a parentName="p" {...{
        "href": "http://www.csszengarden.com/"
      }}>{`the power of css`}</a></p>
    <hr></hr>
    <h1>{`JavaScript`}</h1>
    <Notes mdxType="Notes">
      <ul>
        <li parentName="ul">{`it makes websites interactive`}</li>
        <li parentName="ul">{`alert boxes, refreshes, games etc`}</li>
      </ul>
    </Notes>
    <hr></hr>
    <h1>{`How the web has evolved`}</h1>
    <p><a parentName="p" {...{
        "href": "https://worldwideweb.cern.ch/browser/"
      }}>{`First browser`}</a></p>
    <img src={spacejam} alt="space jam screenshot" />
    <Notes mdxType="Notes">
      <ul>
        <li parentName="ul">{`the internet was created it 1983`}</li>
        <li parentName="ul">{`web was created in 1989`}</li>
        <li parentName="ul">{`internet became popular in 1991 when it opened to the public, but most people didn't have it for another few years`}</li>
        <li parentName="ul">{`originally there was no CSS`}</li>
        <li parentName="ul">{`Websites are more interactive, faster, and easier to use`}</li>
        <li parentName="ul">{`Websites should always work, regardless of how old they are `}</li>
      </ul>
    </Notes>
    <hr></hr>
    <h1>{`demo time!`}</h1>
    <Notes mdxType="Notes">
      <ul>
        <li parentName="ul">{`Keep it simple, don't go into too much detail or show to many elements`}</li>
        <li parentName="ul">{`compare h1 to h1 etc of slides/word`}</li>
        <li parentName="ul">{`explain what each tag does`}</li>
      </ul>
    </Notes>
    <iframe src="https://codesandbox.io/embed/confident-wilson-w36i2?fontsize=14&hidenavigation=1&theme=dark&module=index.html" style={{
      width: "100%",
      height: "500px",
      border: 0,
      borderRadius: "4px",
      overflow: "hidden"
    }} title="confident-wilson-w36i2" allow="accelerometer; ambient-light-sensor; camera; encrypted-media; geolocation; gyroscope; hid; microphone; midi; payment; usb; vr" sandbox="allow-forms allow-modals allow-popups allow-presentation allow-same-origin allow-scripts"></iframe>
    <hr></hr>
    <h1>{`Any questions?`}</h1>
    </MDXLayout>;
}

;
MDXContent.isMDXComponent = true;